import { useEffect } from 'react'
import { useRouter } from 'next/router'
import classes from './MarketplaceCollectionCard.module.scss'
import { dataLayerViewProductList } from '@/utils/dataLayer'
import MarketCollectionCard from '@/components/Cards/MarketCollectionCard'

const MarketplaceCollectionCard = ({ fields }) => {
  const router = useRouter()

  const {
    backgroundColor: bgColor,
    mappedProducts,
    useFlyout,
    usePricing,
    useATC,
  } = fields

  useEffect(() => {
    dataLayerViewProductList({ products: mappedProducts, url: router.asPath })
  }, [])

  return (
    <section
      style={{
        background: bgColor
          ? `rgba(${bgColor.rgb.r}, ${bgColor.rgb.g}, ${bgColor.rgb.b}, ${bgColor.rgb.a})`
          : null,
      }}
      className={`${classes['collection-list__container']}`}
    >
      <div className={classes['collection-list__main']}>
        <ul className={classes['collection-list__product-list']}>
          {mappedProducts.map((product, index) => (
            <MarketCollectionCard
              key={product.content?.handle}
              title={product.content?.title}
              description={product.description}
              images={product.content?.media}
              sanityImages={product.sanityData?.productImages}
              product={product}
              useFlyout={useFlyout}
              usePricing={usePricing}
              useATC={true}
              position={index + 1}
            />
          ))}
        </ul>
      </div>
    </section>
  )
}

export default MarketplaceCollectionCard
